import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full flex gap-1 md:gap-3" }
const _hoisted_2 = { class: "flex gap-1 md:gap-3" }
const _hoisted_3 = { class: "text-center flex-shrink-0" }
const _hoisted_4 = ["onClick", "onKeypress", "tabindex"]
const _hoisted_5 = { class: "max-md:max-w-[50px]" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs leading-xs text-base-200 mt-1"
}

import { StepType } from '~src/admin/types';

// Props with default values

export default /*@__PURE__*/_defineComponent({
  __name: 'Steps',
  props: {
    steps: {},
    activeIndex: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: _normalizeClass([Number(i) !== Number(_ctx.steps.length - 1) && 'flex-1'])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass([
                            'inline-grid place-items-center text-base-300 border-neutral-300 bg-neutral-100 border mb-2 size-6 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
                            _ctx.activeIndex === i && '!bg-primary-500 border-primary-500 text-white',
                            i < _ctx.activeIndex && 'text-primary-500 bg-primary-50 border-primary-100 hover:cursor-pointer',
                        ]),
              onClick: ($event: any) => (i < _ctx.activeIndex && step.callback()),
              onKeypress: _withKeys(($event: any) => (i < _ctx.activeIndex && step.callback()), ["enter","space"]),
              tabindex: i <= _ctx.activeIndex && '0'
            }, _toDisplayString(i + 1), 43, _hoisted_4),
            _createElementVNode("p", _hoisted_5, _toDisplayString(step.label), 1)
          ]),
          (Number(i) !== Number(_ctx.steps.length - 1))
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass([
                        'inline-block w-full h-px bg-neutral-500 mt-[11px] transition-colors',
                        i < _ctx.activeIndex && '!bg-primary-500',
                    ])
              }, null, 2))
            : _createCommentVNode("", true)
        ]),
        (step.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(step.description), 1))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})